import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import TaskCard from './Card'
import {List, ListItem} from 'material-ui/List'

import { doc, dirtyRead } from 'selectors/common'
import { projectTasks } from 'selectors/tasks'

let select = dirtyRead(
	(state, props) => {
		return ({
			tasks: projectTasks(state, props)
		})
	}
)

export class TaskList extends Component {
	render() {
		let { props } = this
	    return(
			<List
				style={{
					backgroundColor: "transparent"
					, paddingTop: "0"
				}}
			>
				{
				(props.tasks.length)?
					R.map(task => <TaskCard task={task} />, props.tasks)
					:
					<p style={{margin:"20px 0 20px 20pt", color: "#A0A0A0"}}>No tasks</p>
				}
			</List>
	    )
	}
}
export default connect(select)(TaskList)



// WEBPACK FOOTER //
// ./src/routes/landlord/projectForm/tasks/List.js